module.exports = __webpack_public_path__ + "static/scale-model-of-flat-branch-park-in-columbia-missouri-151d40d4722ef2c6988b12dc4ee90613.png";